import { styled } from "@acko-tech/building-blocks.ui.common";

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: max-content;
  margin-bottom: 16px;
`;

export const Title = styled.div`
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.1px;
  color: #040222;
  margin-bottom: 12px;
`;

export const NcbContent = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: #5b5675;
`;
